import React from 'react';
import PhoneNumberInput from 'apollo-react/components/PhoneNumberInput';
import FieldWrapper from '../../fields/FieldWrapper';

const PhoneFieldInput = ({
  id,
  label,
  value,
  onChange,
  onBlur,
  helperText,
  showError,
  disabled,
  required,
  columnStyle,
  countryCode,
}) => {
  const phoneCountry = (countryCode || 'eg').toLowerCase();

  return (
    <FieldWrapper style={columnStyle}>
      <PhoneNumberInput
        id={id}
        name={id}
        label={label}
        value={value || ''}
        onChange={onChange}
        onBlur={onBlur}
        helperText={helperText}
        error={showError}
        disabled={disabled}
        required={required}
        defaultCountry={phoneCountry}
        fullWidth
      />
    </FieldWrapper>
  );
};

export default PhoneFieldInput;
